import { Carousel } from "react-responsive-carousel";
import { BiLeftArrow, BiRightArrow } from 'react-icons/bi';
import data_overview from "../data/testimonails_overview.json";
import data_startups from "../data/testimonails_startups.json";
import styles from './TestimonialCarousel.module.css';

export const TestimonialCarousel = ({ bg, pageName, iconsColor }) => {

   const data = pageName === "overview"? data_overview : data_startups;

   return (
      <div className={styles.testimonialCarousel}
         style={{ background: bg }}
         id={(window.location.pathname.includes("startups")
            || window.location.pathname.includes("registration"))
            ? "testimonial-carousel" : undefined}
      >
         <i className={styles.quoteIcon}>
            <svg width="107" height="90" viewBox="0 0 107 90" fill="none"
               xmlns="http://www.w3.org/2000/svg">
               <g clipPath="url(#clip0_2954_8178)">
                  <path d="M49.0909 53.1818V77.7273C49.0909 81.1364 47.8977 84.0341 45.5114 86.4205C43.125 88.8068 40.2273 90 36.8182 90H12.2727C8.86364 90 5.96591 88.8068 3.57955 86.4205C1.19318 84.0341 0 81.1364 0 77.7273V32.7273C0 28.2955 0.862926 24.0661 2.58878 20.0391C4.31463 16.0121 6.64773 12.5284 9.58807 9.58807C12.5284 6.64773 16.0121 4.31463 20.0391 2.58878C24.0661 0.862926 28.2955 0 32.7273 0H36.8182C37.9261 0 38.8849 0.40483 39.6946 1.21449C40.5043 2.02415 40.9091 2.98295 40.9091 4.09091V12.2727C40.9091 13.3807 40.5043 14.3395 39.6946 15.1491C38.8849 15.9588 37.9261 16.3636 36.8182 16.3636H32.7273C28.2102 16.3636 24.3537 17.9616 21.1577 21.1577C17.9616 24.3537 16.3636 28.2102 16.3636 32.7273V34.7727C16.3636 36.4773 16.9602 37.9261 18.1534 39.1193C19.3466 40.3125 20.7955 40.9091 22.5 40.9091H36.8182C40.2273 40.9091 43.125 42.1023 45.5114 44.4886C47.8977 46.875 49.0909 49.7727 49.0909 53.1818ZM106.364 53.1818V77.7273C106.364 81.1364 105.17 84.0341 102.784 86.4205C100.398 88.8068 97.5 90 94.0909 90H69.5455C66.1364 90 63.2386 88.8068 60.8523 86.4205C58.4659 84.0341 57.2727 81.1364 57.2727 77.7273V32.7273C57.2727 28.2955 58.1357 24.0661 59.8615 20.0391C61.5874 16.0121 63.9205 12.5284 66.8608 9.58807C69.8011 6.64773 73.2848 4.31463 77.3118 2.58878C81.3388 0.862926 85.5682 0 90 0H94.0909C95.1989 0 96.1577 0.40483 96.9673 1.21449C97.777 2.02415 98.1818 2.98295 98.1818 4.09091V12.2727C98.1818 13.3807 97.777 14.3395 96.9673 15.1491C96.1577 15.9588 95.1989 16.3636 94.0909 16.3636H90C85.483 16.3636 81.6264 17.9616 78.4304 21.1577C75.2344 24.3537 73.6364 28.2102 73.6364 32.7273V34.7727C73.6364 36.4773 74.233 37.9261 75.4261 39.1193C76.6193 40.3125 78.0682 40.9091 79.7727 40.9091H94.0909C97.5 40.9091 100.398 42.1023 102.784 44.4886C105.17 46.875 106.364 49.7727 106.364 53.1818Z"
                     fill={iconsColor} />
               </g>
               <defs>
                  <clipPath id="clip0_2954_8178">
                     <rect width="106.364" height="90" fill="white" />
                  </clipPath>
               </defs>
            </svg>
         </i>
         {
            <div className={styles.carouselContainer}>
               <Carousel
                  autoPlay
                  interval={5000}
                  infiniteLoop={true}
                  showArrows={true}
                  showStatus={false}
                  showThumbs={false}
                  renderArrowPrev={(clickHandler, hasPrev, label) => {
                     return (
                        <span className={styles.arrowLeft} onClick={clickHandler}>
                           <BiLeftArrow style={{ color: iconsColor }} />
                        </span>
                     )
                  }}
                  renderArrowNext={(clickHandler, hasNext, label) => {
                     return (
                        <span className={styles.arrowRight} onClick={clickHandler}>
                           <BiRightArrow style={{ color: iconsColor }} />
                        </span>
                     )
                  }}
                  renderIndicator={false}
               // DOTS //

               // renderIndicator={(onClickHandler, isSelected, index, label) => {
               //   const defStyle = {
               //     marginLeft: 20,
               //     color: "white",
               //     cursor: "pointer",
               //   };
               //   const style = isSelected
               //     ? { ...defStyle, color: iconsColor }
               //     : { ...defStyle };
               //   return (
               //     <span
               //       style={{ style }}
               //       onClick={onClickHandler}
               //       onKeyDown={onClickHandler}
               //       value={index}
               //       key={index}
               //       role="button"
               //       tabIndex={0}
               //       aria-label={`${label} ${index + 1}`}
               //     >
               //       <GoPrimitiveDot style={style} />
               //     </span>
               //   );
               // }}
               >
                  {
                     data.map((item, index) => (
                        <div className={styles.carouselItem} key={index}>
                           <h4>{item.content}</h4>
                           <div className={styles.carouselDetails}>
                              <img className="rounded-circle"
                                 style={{ width: "115px", height: "115px" }}
                                 src={item.image_url} alt={item.image_url} />
                              <h5>{item.name}, {item.company}</h5>
                           </div>
                        </div>
                     ))
                  }
               </Carousel>
            </div>
         }
      </div >
   );
};